import { format as dateFnsFormat } from 'date-fns';
import * as dateFnsLocales from 'date-fns/locale';

import { LANGUAGE_ZH } from '../constants';

export default async function formatDateAsync(date, format, locale) {
  const currentLocale = () => {
    /**
     * date-fns locales:
     * https://github.com/date-fns/date-fns/blob/master/src/locale/index.js
     */
    if (locale === LANGUAGE_ZH) return 'zhCN';

    // if the locale name contains hyphen (dash)
    // if (locale.includes('-')) {
    //   const newName = locale.replace('-', '');
    //   return newName;
    // }

    return locale;
  };

  return dateFnsFormat(date, format, {
    locale: dateFnsLocales[currentLocale()]
  });
}
